import React, { useState } from "react";
import "./HomePage.scss";
import { useCustomerFaqsListQuery } from "../../../Services/faqs/FAQs";

const FAQ = () => {
  const [expandedItems, setExpandedItems] = useState({ 0: true });
  const [showAllFAQs, setShowAllFAQs] = useState(false);

  const { data: allFaqsData, isLoading } = useCustomerFaqsListQuery({});

  const toggleExpanded = (id) => {
    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleViewAll = () => {
    setShowAllFAQs(!showAllFAQs);
  };

  // Use API data if available, fallback to empty array
  const faqData = allFaqsData?.results || [];

  // Show first 4 items initially, all items when "View All" is clicked
  const displayedFAQs = showAllFAQs ? faqData : faqData.slice(0, 4);

  if (isLoading) {
    return <div>Loading FAQs...</div>;
  }

  return (
    <div className="faq-container">
      <div className="faq-header">
        <p className="faq-subtitle">Frequently Asked Questions</p>
        <h1 className="faq-title">Got Questions? We've Got Answers</h1>
      </div>

      <div className="faq-list">
        {displayedFAQs.map((item, index) => (
          <div key={item.id} className="faq-item">
            <button
              className="faq-question"
              onClick={() => toggleExpanded(item.id)}
            >
              <h3 className="faq-question-text">{item.question}</h3>
              <span className="faq-icon">
                <span
                  className={`icon ${
                    expandedItems[item.id] ? "minus" : "plus"
                  }`}
                ></span>
              </span>
            </button>
            <div
              className={`faq-answer ${
                expandedItems[item.id] ? "expanded" : ""
              }`}
            >
              <p className="faq-answer-text">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>

      {faqData.length > 4 && (
        <div className="view-all-container">
          <button className="view-all-btn" onClick={handleViewAll}>
            {showAllFAQs ? "Show Less" : "View All"}
            <span className="arrow">{showAllFAQs ? "↑" : "→"}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default FAQ;
